import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OccCareerHeaderComponent } from './occ-shared/occ-common-header/occ-career-header-component';
import { OccClusterHeaderComponent } from './occ-shared/occ-common-header/occ-cluster-header-component';
import { OccEmergHeaderComponent } from './occ-shared/occ-common-header/emergCareers-header-component';
import { OccIndexComponent } from './occ-shared/occ-index/occ-index-component';
import { OccCompareComponent } from './occ-compare/occ-compare.component';

export const routes: Routes = [
    { path: 'occCareer', component: OccCareerHeaderComponent },
    { path: 'occCluster', component: OccClusterHeaderComponent },
    { path: 'occEmergCareer', component: OccEmergHeaderComponent },
    { path: 'occIndex', component: OccIndexComponent },
    { path: 'compare', component: OccCompareComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class OccDetailsRoutingModule { }
